<!-- CV/RL Priority -->
<template>
  <div class="edit-priority-con">
    <div>
      <div>
        <div class="edit-priority-con-title">
          <zlr-title title="CV/RL Priority"></zlr-title>
        </div>
        <Form ref="formValidate"
              :model="formValidate"
              :rules="ruleValidate"
              label-position="top">
          <ul class="edit-priority-con-search-con">
            <li style="width:520px;">
              <FormItem label="CV/RL">
                <Select v-model="formValidate.title"
                        placeholder="Select"
                        clearable>
                  <Option v-for="(item, index) in cvrlList"
                          :key="index"
                          :value="item">{{item}}</Option>
                </Select>
              </FormItem>
            </li>
            <li>
              <FormItem label="Turnaround DDL">
                <DatePicker type="datetimerange"
                            placeholder="Select date"
                            format="yyyy-MM-dd"
                            style="width:100%;"
                            @on-change="changeTime($event, 'deadLineStartTime', 'deadLineEndTime')"></DatePicker>
              </FormItem>
            </li>
            <li>
              <FormItem label="Mentee">
                <Select v-model="formValidate.menteeNum"
                        placeholder="Select"
                        clearable>
                  <Option v-for="(item, index) in menteeList"
                          :key="index"
                          :value="item.menteeNum">{{item.menteeEnName}}</Option>
                </Select>
              </FormItem>
            </li>
            <li style="width:96px;">
              <Button class="zlr-btn-default"
                      @click="handleSearch">Search</Button>
            </li>
          </ul>
        </Form>
        <template v-if="tableData.length">
          <Table :columns="columnsData"
                 :data="tableData"></Table>
          <div class="edit-priority-con-page">
            <Page :total="totalItems"
                  :page-size="pageSize"
                  :current="currentPage"
                  @on-change="handlePageChange"></Page>
          </div>
        </template>
        <zlr-empty v-else></zlr-empty>
      </div>
    </div>
  </div>
</template>

<script>
// less
import './index.less'
import { getMaterialQueryDeadlineList, getMaterialQueryDeadlineCvRl } from '@/api/material'
// components
import ZlrTitle from '_c/title/title'
import ZlrEmpty from '_c/empty/empty'
import { mapState } from 'vuex'
import mixinsPage from '@/view/mixins/page'
export default {
  name: '',
  components: { ZlrTitle, ZlrEmpty },
  mixins: [mixinsPage],
  data () {
    return {
      formValidate: {
        menteeNum: '',
        deadLineEndTime: '',
        deadLineStartTime: '',
        title: ''
      },
      ruleValidate: {},
      columnsData: [
        {
          title: 'Mentee name',
          key: 'menteeName',
          align: 'center',
          width: 180
        },
        {
          title: 'CV/RL',
          key: 'title'
        },
        {
          title: 'Turnaround DDL',
          key: 'deadLine',
          align: 'center',
          maxWidth: 240,
          render: (h, params) => {
            return h('span', {
              style: {
                color: '#6589dd',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'mentee-cv-rl',
                    params: {
                      id: params.row.menteeNum
                    }
                  })
                }
              }
            }, params.row.deadLine || '--')
          }
        }
      ],
      tableData: [],
      cvrlList: []
    }
  },
  computed: {
    ...mapState({
      'menteeList' (state) {
        return state.mentee.menteeList || []
      }
    })
  },
  mounted () {
    this.getCvRlList()
    this.getPageList()
  },
  methods: {
    // 获取CV/RL信息
    getCvRlList () {
      getMaterialQueryDeadlineList({}).then(res => {
        if (res.code === 0) {
          this.cvrlList = res.data.model.cvrl
        }
      })
    },
    getPageList () {
      let data = {
        ...this.formValidate,
        currentPage: this.currentPage - 1,
        pageSize: this.pageSize
      }
      getMaterialQueryDeadlineCvRl(data).then(res => {
        let page = res.data.page
        this.tableData = page.result
        this.totalItems = page.totalItems
      }).catch(() => {
        this.tableData = []
        this.totalItems = 0
        this.pageSize = 1
      })
    },
    // 时间
    changeTime (data, start, end) {
      this.formValidate[start] = data[0] && `${data[0]} 00:00:00`
      this.formValidate[end] = data[1] && `${data[1]} 23:59:59`
    }
  }
}
</script>
<style lang='less' scoped>
</style>
